import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SuperFooterService, EActiveTabStatus, ESupportType, IAttachment } from '../services/super-footer.service';
import { CommonUtil } from '../Utils/common-util';
import { FacilityService } from '../services/facility.service';
import { Subscription } from 'rxjs';
import { AmplitudeAnalyticsService } from '../services/amplitude-analytics.service';

@Component({
  selector: 'app-request-a-technician-visit',
  templateUrl: './request-a-technician-visit.component.html',
  styleUrls: ['./request-a-technician-visit.component.scss']
})
export class RequestATechnicianVisitComponent implements OnInit, OnDestroy {
  public activeTabIndex: EActiveTabStatus = EActiveTabStatus.FORM;
  public form: FormGroup;
  public formEditMode: boolean = false;
  public submitted: boolean = false;
  public captchaVarified: boolean = false;
  public attachments: IAttachment[] = [];
  public isInvalidFileFormat: boolean = false;
  public isMaxSizeExcede: boolean = false;
  showUploadControl = true;
  // subscriptions
  private _facilityOnChange: Subscription;
  cancelModalProps = {
    title: 'MODAL.CANCEL.REQUEST',
    message: 'MODAL.ALERT.CANCEL.SUPPORT.REQUEST',
    isWarningPopup: true,
    ctaButtonLabel: 'YES',
    negativeButtonLabel: 'NO',
    isCloseIconCallsCta: true,
    hideSecondaryButton: false,
  };
  showCancelModal = false;

  // cancel event
  @Output() cancel = new EventEmitter();

  constructor(private service: SuperFooterService, public u: CommonUtil, private _facilityService: FacilityService,
    private _amplitudeService: AmplitudeAnalyticsService) { }

  ngOnInit() {
    this.initForm();
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  changeTab(index: EActiveTabStatus) {
    this.activeTabIndex = index;
  }

  initForm() {
    this.form = this.service.initForm(ESupportType.TECHNICIAN_VISIT);

    // first time
    this.service.updateDefaultDataToFrom(this.form);

    // when facility change
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.service.updateDefaultDataToFrom(this.form);
    });
  }

  // get fields for form validation message display purpose
  get field() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;

    // form validation
    if (this.form.invalid) {
      return;
    }

    // if form is valid, then navigate to confirm page
    if (this.activeTabIndex === EActiveTabStatus.FORM) {
      // navigate to confirmation tab
      this.changeTab(EActiveTabStatus.CONFIRMATION);
      return;
    }

    this._amplitudeService.logEvent({elementName: 'Submit', action: 'Click'}, 'Request Technician');
    // if valid and in confirm page, then submit the form.
    this.service.submit(ESupportType.TECHNICIAN_VISIT, this.form.value, this.attachments).then(
      (res: any) => {
        this.onReset();
        this.cancel.emit();
        this.initForm();
        this.changeTab(0);
      },
      (err: any) => {         
        console.error('API failed.');
      }
    );
  }

  onReset() {
    this.submitted = false;
    this.form.reset();
    this.service.updateDefaultDataToFrom(this.form);
    this.attachments = [];
    this.isInvalidFileFormat = false;
    this.isMaxSizeExcede = false;
  }

  onCancel() {
    this.showCancelModal = true;
  }

  cancelServiceRequest() {
    this.showCancelModal = false;
    this.cancel.emit();
    this.onReset();
    this.initForm();
    this.changeTab(0);
  }

  closeCancelModal() {
    this.showCancelModal = false;

  }

  onCaptchaStatusChange(status: string): void {
    this.captchaVarified = status === 'success';
  }

  onFileSelect(event:Event) {
    let file = (<HTMLInputElement>event.target).files;
    console.log('---files---',file);
    const attachments = this.fileOnChange(file);
    this.attachments = attachments;
  }

  onFileDelete(index:number) {
    this.attachments = this.attachments.filter((item, i) => {
      return index !== i;
    });
    this.validateAttachments();
    // Implemented showUploadControl true/false to reset the file input.
    this.showUploadControl = false;     
      this.showUploadControl = true;  
  }

  validateAttachments(){
    let validSize = true;
    let validType = true;
    let restrictedTypes=['ADE', 'ADP', 'BAT', 'CHM', 'CMD', 'COM', 'CPL', 'EXE', 'HTA', 'INS', 'ISP', 'JAR', 'JSE', 'LIB', 'LNK', 'MDE', 'MSC', 'MSP', 'MST', 'PIF', 'SCR', 'SCT', 'SHB', 'SYS', 'VB', 'VBE', 'VBS', 'VXD', 'WSC', 'WSF', 'WSH'];
    let totalSize = 0;
    this.attachments.forEach(item => {      
      totalSize += item.size;
      let ext:any = item.name.split(".");
      ext = ext[ext.length-1].toUpperCase(); 
      if(restrictedTypes.indexOf(ext) > -1){
				validType = false;
			}
    });
    if(totalSize > 10485760) {
      validSize = false;
    }
    this.isMaxSizeExcede = !validSize;
    this.isInvalidFileFormat = !validType;
  }

  fileOnChange(files: any) {
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        let size = Math.round((files.item(i).size / 1024 / 1024) * 100) / 100;
        this.attachments.push({
          file: files.item(i),
          name: files.item(i).name,
          size: files.item(i).size,
          mb: `${size} MB`,
          type: files.item(i).type,
        });        
      }
    }
    this.validateAttachments();

    return this.attachments;
  }
}
